<div class="flex justify-between items-center p-4 px-3 bg-third-level rounded-lg h-auto">
  <div class="text-(--color-red) text-md">
    {{ deadlineTranslationKey() | transloco }}:
    <strong>{{ deadlineValue() | appDate }}</strong>
  </div>
  <div class="flex items-center gap-3">
    <ng-content />
    @if (canFinish()) {
      <p-button
        data-testid="questionnaire-header-btn"
        [label]="finishButtonTranslationKey() | transloco"
        (onClick)="finishClick.emit()"
        [loading]="isFinishing()"
        severity="primary"
        icon="pi pi-send"
        iconPos="right"
      />
    }
  </div>
</div>
